import { render, staticRenderFns } from "./albumOptions.vue?vue&type=template&id=c509b1ca&"
import script from "./albumOptions.vue?vue&type=script&lang=js&"
export * from "./albumOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports